import { Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'dtis-search-input',
  imports: [MatIconModule],
  templateUrl: './search-input.component.html',
  host: {
    class: 'block w-full',
    '[class.compact]': 'compact()',
  },
  styles: [
    `
      :host(.compact) .search-input-container {
        height: 40px;
        gap: 3px;
        padding: 3px;
      }

      :host(.compact) .search-input-leading,
      :host(.compact) .search-input-clear {
        width: 34px;
        height: 34px;
      }

      :host(.compact) .search-input-icon {
        width: 18px;
        height: 18px;
        font-size: 18px;
        line-height: 18px;
      }

      :host(.compact) .search-input-placeholder {
        inset-inline: 3px;
        font-size: 12px;
        line-height: 17px;
      }

      :host(.compact) .search-input-field {
        height: 34px;
        padding-inline: 3px;
        font-size: 12px;
        line-height: 17px;
      }
    `,
  ],
})
export class DtisSearchInputComponent {
  readonly value = input('');
  readonly placeholder = input('Search');
  readonly label = input('Search');
  readonly compact = input(false);
  readonly valueChange = output<string>();
  readonly cleared = output<void>();

  onInput(event: Event): void {
    const input = event.target;
    if (input instanceof HTMLInputElement) {
      this.valueChange.emit(input.value);
    }
  }

  clear(): void {
    this.valueChange.emit('');
    this.cleared.emit();
  }
}
